module.exports = __webpack_public_path__ + "img/fleet.982fed81.png";